import type { TargetedPointerEvent } from 'preact'
import { useRef } from 'preact/hooks'
import type { VirtualInput } from '#contract'
import styles from './look-area.module.css'

interface Drag {
  readonly pointerId: number
  readonly x: number
  readonly y: number
}

/** Drag anywhere in it to look around. One finger at a time. */
export function LookArea({ touch }: { readonly touch: VirtualInput }) {
  const dragRef = useRef<Drag | null>(null)

  const onDown = (event: TargetedPointerEvent<HTMLDivElement>): void => {
    if (dragRef.current) return
    event.currentTarget.setPointerCapture(event.pointerId)
    dragRef.current = { pointerId: event.pointerId, x: event.clientX, y: event.clientY }
  }

  const onMove = (event: TargetedPointerEvent<HTMLDivElement>): void => {
    const current = dragRef.current
    if (current?.pointerId !== event.pointerId) return
    touch.addLook(event.clientX - current.x, event.clientY - current.y)
    dragRef.current = { ...current, x: event.clientX, y: event.clientY }
  }

  const onEnd = (event: TargetedPointerEvent<HTMLDivElement>): void => {
    if (dragRef.current?.pointerId === event.pointerId) dragRef.current = null
  }

  return (
    <div
      class={styles.area}
      onPointerDown={onDown}
      onPointerMove={onMove}
      onPointerUp={onEnd}
      onPointerCancel={onEnd}
    />
  )
}
